import React from 'react'
import { Card, Col } from 'react-angle-dashboard-components'
import { CardRow } from './styles'
import { CTPProcedure } from '../../services/cpt'

const ProcedureInfo: React.FC<{ title: string; desc: string }> = ({
  title,
  desc
}) => {
  return (
    <Col className="px-1">
      <Card className="p-2">
        <small
          className="text-muted fs-8 mb-0"
          style={{ whiteSpace: 'nowrap' }}
        >
          {title}
        </small>
        <b className="fs-16">{desc || ' - '}</b>
      </Card>
    </Col>
  )
}

export const ProcedureDetails: React.FC<{ procedure: CTPProcedure }> = ({
  procedure
}) => {
  const procedures = [
    { title: 'Required Auth', desc: procedure.auth_required ? 'Yes' : 'No' },
    {
      title: 'Age Restricted',
      desc: procedure.age_restricted ? 'Yes' : 'No'
    },
    {
      title: 'Gender Restricted',
      desc: procedure.gender_restricted ? 'Yes' : 'No'
    },
    { title: 'From Age', desc: procedure.from_age },
    { title: 'Thru Age', desc: procedure.thru_age },
    { title: 'Gender', desc: procedure.gender },
    { title: 'Effective Date', desc: procedure.effective_date },
    { title: 'Term Date', desc: procedure.term_date }
  ]

  return (
    <CardRow className="border py-3 rounded-bottom">
      {procedures.map((p, i) => (
        <ProcedureInfo key={i} {...p} />
      ))}
    </CardRow>
  )
}
